export default "__VITE_ASSET__VTt4sPan__"